<template>
  <TableCard class="evaluation-table">
    <thead slot="thead">
      <tr>
        <th class="typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th">
          {{ $t('evaluations.table.number') }}
        </th>
        <th class="typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th">
          {{ $t('evaluations.table.student_name') }}
        </th>
        <th class="typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th">
          {{ $t('evaluations.table.comment') }}
        </th>
      </tr>
    </thead>

    <tbody slot="tbody">
      <EvaluationTableRow
        v-for="evaluation in evaluationList"
        v-bind:key="evaluation.student_id"
        v-bind:evaluation="evaluation"
        v-bind:selected-domain-ids="selectedDomainIds"
      />
    </tbody>

  </TableCard>
</template>

<script>
  import EvaluationTableRow from './EvaluationTableRow';

  export default {
    name: 'evaluation-table',

    components: {
      EvaluationTableRow,
    },

    props: {
      evaluationList: {
        type: Array,
        default: null,
      },
      selectedDomainIds: {
        type: Array,
        default: null,
      },
    },
  };
</script>

<style lang="scss">
  .evaluation-table {
    .card-block {
      padding: 0;
    }

    .table {
      margin-bottom: 0;
    }

    .evaluation-table-th {
      padding-left: 22px;
      padding-top: 15px;
      padding-bottom: 12px;
      padding-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/evaluations/components/EvaluationTable.vue